"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuex = require("vuex");
var _AutocompleteSelect = _interopRequireDefault(require("@/ui/components/inputs/AutocompleteSelect.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var CONTRACT_STATUS_OPTIONS = [{
  label: 'Aguardando produção',
  value: 1
}, {
  label: 'Em atraso',
  value: 2
}, {
  label: 'Concluído',
  value: 3
}];
var LOT_TYPE_OPTIONS = [{
  label: 'Todos',
  value: 'lot'
}, {
  label: 'Estaquia',
  value: 'cut'
}, {
  label: 'Enxertia',
  value: 'graft'
}];
var _default2 = exports.default = {
  components: {
    AutocompleteSelect: _AutocompleteSelect.default
  },
  name: 'CreateContractModal',
  props: {
    isModalActive: {
      type: Boolean,
      default: false
    },
    isSaving: {
      type: Boolean,
      default: false
    },
    contract: {
      type: Object,
      default: function _default() {
        return null;
      }
    },
    customers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    lots: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    onFetchLots: {
      type: Function,
      default: null
    },
    onFetchCustomers: {
      type: Function,
      default: null
    }
  },
  emits: ['submit', 'onClose'],
  data: function data() {
    return {
      form: this.createDefaultForm(),
      lotsItems: this.addDisplayFields(this.lots),
      customerItems: this.addCustomerDisplayFields(this.customers)
    };
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)({
    farm: 'GET_FARM'
  })), {}, {
    isEdit: function isEdit() {
      var _this$contract;
      return Boolean((_this$contract = this.contract) === null || _this$contract === void 0 ? void 0 : _this$contract.id);
    },
    statusOptions: function statusOptions() {
      return CONTRACT_STATUS_OPTIONS;
    },
    lotTypeOptions: function lotTypeOptions() {
      return LOT_TYPE_OPTIONS;
    },
    graftLotType: function graftLotType() {
      var _LOT_TYPE_OPTIONS$fin, _LOT_TYPE_OPTIONS$fin2;
      return (_LOT_TYPE_OPTIONS$fin = (_LOT_TYPE_OPTIONS$fin2 = LOT_TYPE_OPTIONS.find(function (option) {
        return option.value === 'graft';
      })) === null || _LOT_TYPE_OPTIONS$fin2 === void 0 ? void 0 : _LOT_TYPE_OPTIONS$fin2.value) !== null && _LOT_TYPE_OPTIONS$fin !== void 0 ? _LOT_TYPE_OPTIONS$fin : 'graft';
    }
  }),
  watch: {
    isModalActive: function isModalActive(active) {
      if (active) {
        this.form = this.createDefaultForm(this.contract);
        this.lotsItems = this.addDisplayFields(this.lots);
        this.customerItems = this.addCustomerDisplayFields(this.customers);
      }
    },
    contract: {
      handler: function handler(value) {
        if (this.isModalActive) {
          this.form = this.createDefaultForm(value);
        }
      },
      deep: true
    },
    lots: {
      handler: function handler(newLots) {
        this.lotsItems = this.addDisplayFields(newLots);
      },
      deep: true
    },
    customers: {
      handler: function handler(newCustomers) {
        this.customerItems = this.addCustomerDisplayFields(newCustomers);
      },
      deep: true
    }
  },
  methods: {
    createDefaultForm: function createDefaultForm() {
      var _ref, _contract$client$id, _contract$client, _contract$contractNum, _contract$totalPlants, _contract$status, _contract$lotType;
      var contract = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return {
        clientId: (_ref = (_contract$client$id = contract === null || contract === void 0 ? void 0 : (_contract$client = contract.client) === null || _contract$client === void 0 ? void 0 : _contract$client.id) !== null && _contract$client$id !== void 0 ? _contract$client$id : contract === null || contract === void 0 ? void 0 : contract.clientId) !== null && _ref !== void 0 ? _ref : null,
        contractNumber: (_contract$contractNum = contract === null || contract === void 0 ? void 0 : contract.contractNumber) !== null && _contract$contractNum !== void 0 ? _contract$contractNum : '',
        signatureDate: this.parseDate(contract === null || contract === void 0 ? void 0 : contract.signatureDate),
        paymentTermDate: this.parseDate(contract === null || contract === void 0 ? void 0 : contract.paymentTermDate),
        deliveryDate: this.parseDate(contract === null || contract === void 0 ? void 0 : contract.deliveryDate),
        totalPlants: (_contract$totalPlants = contract === null || contract === void 0 ? void 0 : contract.totalPlants) !== null && _contract$totalPlants !== void 0 ? _contract$totalPlants : null,
        status: (_contract$status = contract === null || contract === void 0 ? void 0 : contract.status) !== null && _contract$status !== void 0 ? _contract$status : CONTRACT_STATUS_OPTIONS[0].value,
        lotType: (_contract$lotType = contract === null || contract === void 0 ? void 0 : contract.lotType) !== null && _contract$lotType !== void 0 ? _contract$lotType : LOT_TYPE_OPTIONS[0].value,
        lotIds: Array.isArray(contract === null || contract === void 0 ? void 0 : contract.lots) ? contract.lots.map(function (lot) {
          return lot.id;
        }) : []
      };
    },
    addCustomerDisplayFields: function addCustomerDisplayFields(customers) {
      if (!Array.isArray(customers)) return [];
      return customers.map(function (customer) {
        var _customer$name, _customer$cpfCnpj;
        return _objectSpread(_objectSpread({}, customer), {}, {
          title: (_customer$name = customer === null || customer === void 0 ? void 0 : customer.name) !== null && _customer$name !== void 0 ? _customer$name : '',
          description: (_customer$cpfCnpj = customer === null || customer === void 0 ? void 0 : customer.cpfCnpj) !== null && _customer$cpfCnpj !== void 0 ? _customer$cpfCnpj : ''
        });
      });
    },
    addDisplayFields: function addDisplayFields(lots) {
      if (!Array.isArray(lots)) return [];
      return lots.map(function (lot) {
        var _lot$code, _lot$id, _lot$cutting, _lot$rootstock, _lot$scion$name, _lot$scion;
        var title = (_lot$code = lot === null || lot === void 0 ? void 0 : lot.code) !== null && _lot$code !== void 0 ? _lot$code : "Lote #".concat((_lot$id = lot === null || lot === void 0 ? void 0 : lot.id) !== null && _lot$id !== void 0 ? _lot$id : '');
        return _objectSpread(_objectSpread({}, lot), {}, {
          title: title,
          description: "\n            ".concat(lot !== null && lot !== void 0 && (_lot$cutting = lot.cutting) !== null && _lot$cutting !== void 0 && _lot$cutting.name ? "(Estaquia) ".concat(lot.cutting.name) : '', "\n            ").concat(lot !== null && lot !== void 0 && (_lot$rootstock = lot.rootstock) !== null && _lot$rootstock !== void 0 && _lot$rootstock.name ? "(Enxertia) ".concat(lot.rootstock.name) : '', "\n            ").concat((_lot$scion$name = lot === null || lot === void 0 ? void 0 : (_lot$scion = lot.scion) === null || _lot$scion === void 0 ? void 0 : _lot$scion.name) !== null && _lot$scion$name !== void 0 ? _lot$scion$name : '')
        });
      });
    },
    fetchLots: function () {
      var _fetchLots = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(params) {
        var _params$search;
        var search, lots;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              search = typeof params === 'string' ? params : (_params$search = params === null || params === void 0 ? void 0 : params.search) !== null && _params$search !== void 0 ? _params$search : '';
              if (!(typeof this.onFetchLots === 'function')) {
                _context.n = 2;
                break;
              }
              _context.n = 1;
              return this.onFetchLots(search);
            case 1:
              lots = _context.v;
              this.lotsItems = this.addDisplayFields(lots);
              return _context.a(2, {
                data: this.lotsItems,
                lastPage: 1
              });
            case 2:
              return _context.a(2, {
                data: this.lotsItems,
                lastPage: 1
              });
          }
        }, _callee, this);
      }));
      function fetchLots(_x) {
        return _fetchLots.apply(this, arguments);
      }
      return fetchLots;
    }(),
    fetchCustomers: function () {
      var _fetchCustomers = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(params) {
        var _params$search2;
        var search, customers;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              search = typeof params === 'string' ? params : (_params$search2 = params === null || params === void 0 ? void 0 : params.search) !== null && _params$search2 !== void 0 ? _params$search2 : '';
              if (!this.onFetchCustomers) {
                _context2.n = 2;
                break;
              }
              _context2.n = 1;
              return this.onFetchCustomers(search);
            case 1:
              customers = _context2.v;
              this.customerItems = this.addCustomerDisplayFields(customers);
              return _context2.a(2, {
                data: this.customerItems,
                lastPage: 1
              });
            case 2:
              return _context2.a(2, {
                data: this.customerItems,
                lastPage: 1
              });
          }
        }, _callee2, this);
      }));
      function fetchCustomers(_x2) {
        return _fetchCustomers.apply(this, arguments);
      }
      return fetchCustomers;
    }(),
    parseDate: function parseDate(value) {
      if (!value) return null;
      var date = new Date(value);
      return Number.isNaN(date.getTime()) ? null : date;
    },
    normalizeDate: function normalizeDate(value) {
      if (!value) return null;
      var date = value instanceof Date ? value : new Date(value);
      return Number.isNaN(date.getTime()) ? null : date;
    },
    handleClose: function handleClose() {
      this.form = this.createDefaultForm();
      this.$emit('onClose');
    },
    submitForm: function submitForm() {
      var _this$farm, _this$contract$id, _this$contract2;
      var farmId = Number((_this$farm = this.farm) === null || _this$farm === void 0 ? void 0 : _this$farm.id);
      if (!Number.isFinite(farmId)) {
        this.$buefy.toast.open({
          message: 'Fazenda inválida.',
          type: 'is-danger'
        });
        return;
      }
      var clientId = Number(this.form.clientId);
      if (!Number.isFinite(clientId)) {
        this.$buefy.toast.open({
          message: 'Selecione o cliente do contrato.',
          type: 'is-danger'
        });
        return;
      }
      var contractNumber = (this.form.contractNumber || '').trim();
      if (!contractNumber) {
        this.$buefy.toast.open({
          message: 'Informe o número do contrato.',
          type: 'is-danger'
        });
        return;
      }
      var signatureDate = this.normalizeDate(this.form.signatureDate);
      var paymentTermDate = this.normalizeDate(this.form.paymentTermDate);
      var deliveryDate = this.normalizeDate(this.form.deliveryDate);
      if (!signatureDate || !paymentTermDate || !deliveryDate) {
        this.$buefy.toast.open({
          message: 'Datas de assinatura, pagamento e entrega são obrigatórias.',
          type: 'is-danger'
        });
        return;
      }
      var totalPlants = Number(this.form.totalPlants);
      if (!Number.isFinite(totalPlants) || totalPlants <= 0) {
        this.$buefy.toast.open({
          message: 'Informe o total de mudas previstas com um número válido.',
          type: 'is-danger'
        });
        return;
      }
      var payload = {
        farmId: farmId,
        clientId: clientId,
        contractNumber: contractNumber,
        signatureDate: signatureDate,
        paymentTermDate: paymentTermDate,
        deliveryDate: deliveryDate,
        totalPlants: totalPlants,
        status: this.form.status,
        lotType: this.form.lotType,
        lotIds: this.form.lotIds
      };
      this.$emit('submit', {
        id: (_this$contract$id = (_this$contract2 = this.contract) === null || _this$contract2 === void 0 ? void 0 : _this$contract2.id) !== null && _this$contract$id !== void 0 ? _this$contract$id : null,
        payload: payload
      });
    }
  }
};